import { render, staticRenderFns } from "./WsPopup.vue?vue&type=template&id=0ec860a7&"
import script from "./WsPopup.vue?vue&type=script&lang=js&"
export * from "./WsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports